import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Image,
  Flex,
} from "@chakra-ui/react";

export default function ProjectModal({ isOpen, onClose, project }) {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (project && project.additionalImages.length > 0) {
      setSelectedImage(project.additionalImages[0]);
    }
  }, [project]);

  if (!project) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} alignItems={"center"} size="6xl">
      <ModalOverlay />
      <ModalContent
        bg="#00000090"
        backdropFilter={"blur(10px)"}
        color="white"
        maxH="90vh"
        overflowY="auto"
        p={4}
        alignContent={"center"}
        height={"fit-content"}
        alignSelf={"center"}
      >
        <ModalHeader
          fontSize="5xl"
          fontWeight="bold"
          textAlign={{ base: "center", lg: "left" }}
          color="#DD9331"
        >
          {project.title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          pb={6}
          display={""}
          alignItems={"center"}
          textAlign={{ base: "center", lg: "left" }}
        >
          <Flex
            direction={{ base: "column-reverse", lg: "row" }}
            alignItems={{ base: "center", lg: "start" }}
            gap={8}
          >
            <Box flex="1">
              <Text fontSize="lg" color="#DD9331" mb={2}>
                {project.subtitle}
              </Text>
              <Text mb={6} lineHeight="1.6">
                {project.detailedDescription}
              </Text>
            </Box>
            <Flex alignItems="center" direction="column" gap={10}> 
              <Flex maxW="400px" maxH="400px">
                <motion.div
                  key={selectedImage}
                  initial={{ scale: 0.95 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                >
                  <Image
                    src={selectedImage}
                    alt={project.title}
                    objectFit={{base:"contain", lg:"cover"}}
                    w="100%"
                    h="100%"
                    borderRadius="lg"
                  />
                </motion.div>
              </Flex>
              <Flex backgroundColor="#F9F0DF10" p={4} borderRadius="lg" direction="column" gap={4}>
                  <Flex gap={4} wrap="wrap" justify={{ base: "center", lg: "start" }}>
                    {project.additionalImages.map((image, index) => (
                      <motion.div
                        key={index}
                        initial={false}
                        animate={image === selectedImage ? "active" : "inactive"}
                        variants={{
                          active: { opacity: 1 },
                          inactive: { opacity: 0.5 },
                        }}
                        transition={{ duration: 0.3 }}
                        style={{
                          width: "80px",
                          height: "80px",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(image)}
                      >
                        <Image
                          src={image}
                          alt={`${project.title} - Image ${index + 1}`}
                          objectFit="contain"
                          w="100%"
                          h="100%"
                          borderRadius="md"
                        />
                      </motion.div>
                    ))}
                  </Flex>
                </Flex>
              </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
